import http, {download, uploadCfg} from "../../../utils/HttpUtils";

//销售订单接口服务
class SaleOrderService {

    /*****************************************************************************/

    //新建销售订单
    static async insert(data) {
        const apiUrl = "/sale/order/insert";
        return await http.post(apiUrl, data);
    }

    //修改销售订单
    static async update(data) {
        const apiUrl = "/sale/order/update";
        return await http.post(apiUrl, data);
    }


    //分页查询销售订单信息
    static async findPage(data) {
        const apiUrl = "/sale/order/findPage";
        return await http.post(apiUrl, data);
    }

    //根据ID查询销售订单信息
    static async findByIdOrCode(idOrCode) {
        const apiUrl = `/sale/order/findByIdOrCode/${idOrCode}`;
        return await http.get(apiUrl);
    }

    //转销售单
    static async shift(id) {
        const apiUrl = `/sale/order/shift/${id}`;
        return await http.get(apiUrl);
    }

    //作废
    static async disable(id) {
        const apiUrl = `/sale/order/disable/${id}`;
        return await http.get(apiUrl);
    }

    //导出
    static async export(data) {
        const apiUrl = `/sale/order/export`;
        return await download(apiUrl, {type: "POST", data});
    }

    /*****************************************************************************/

    //下载明细导入模板
    static async downloadDetailTpl() {
        const apiUrl = "/sale/order/detail/downloadTpl";
        await download(apiUrl,)
    }

    //获取导入配置
    static getImportDetailCfg(cfg, priceType = null) {
        const apiUrl = "/sale/order/detail/import/" + priceType;
        return uploadCfg(apiUrl, cfg);
    }

    /*****************************************************************************/

}

export default SaleOrderService;
